import React from 'react';
import { connect } from 'react-redux';
import { userSignOut } from 'actions/Auth';
import UserInfoModal from 'components/userInfoModal';
import ColorOptionsModal from 'components/colorOptionsModal';
import IntlMessages from 'util/IntlMessages';
import { getIdentityName, getRoleName } from 'services/Authentication';
import { showHideColorOptionsModal, showHideUserInfoModal } from 'actions/index';

class UserInfo extends React.Component {
    
    getModalBody() {
        let modalBodyText = '';
        modalBodyText += '<div className="text-center">'; // concat wont work here ??
        modalBodyText += '<img src="assets/images/coming-soon_225_225.jpg" alt="Coming Soon" />';
        modalBodyText += '<h1>Coming Soon</h1>';
        modalBodyText += '</div>';
        return modalBodyText;
    }

    render() {
        const userName = getIdentityName();
        const roleName = getRoleName();
        const { showHideColorOptionsModal, showHideUserInfoModal } = this.props;
        return (
            <div>
                <div className="user-profile">
                    <img className="user-avatar border-0 size-40" src="assets/images/person-150_150.jpg" alt="User" />
                    <div className="user-detail ml-2">
                        <h4 className="user-name mb-0">{userName}</h4>
                        <small>{roleName}</small>
                    </div>
                </div>
                <ColorOptionsModal
                    actionComponent={
                        <a className="dropdown-item text-muted" href="#" onClick={() => showHideColorOptionsModal()}>
                            <i className="zmdi zmdi-settings zmdi-hc-fw mr-1" />
                            <IntlMessages id="popup.setting" />
                        </a>
                    }
                />
                <UserInfoModal
                    modalTitle={<IntlMessages id="userInfoModal.header" />}
                    modalBody={this.getModalBody()}
                    actionComponent={
                        <a className="dropdown-item text-muted" href="#" onClick={() => showHideUserInfoModal()}>
                            <i className="zmdi zmdi-face zmdi-hc-fw mr-1" />
                            <IntlMessages id="popup.profile" />
                        </a>
                    } />


                <a className="dropdown-item text-muted" href="#" onClick={() => {
                    console.log('Try to logout');
                    this.props.userSignOut();
                }}>
                    <i className="zmdi zmdi-sign-in zmdi-hc-fw mr-1" />
                    <IntlMessages id="popup.logout" />
                </a>
            </div>
        );
    }
}

export default connect(null, { userSignOut, showHideColorOptionsModal, showHideUserInfoModal })(UserInfo);





// WEBPACK FOOTER //
// ./components/UserInfo/index.js